// EduSquarePage.jsx
import React from "react";
import Footer from "../components/footer";

const offerings = [
  { title: "Technical Skills Development", icon: "💻" },
  { title: "Soft Skills Enhancement", icon: "🗣️" },
  { title: "Seminars & Practice Sessions", icon: "🎯" },
  { title: "Industry-aligned Workshops", icon: "🏭" },
];

const EduSquarePage = () => (
  <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-gray-200 px-6 py-12">
        <div className=" mx-auto">
            <h1 className="text-3xl font-bold mb-6 text-green-400">Edu Square</h1>
            <p className="mb-4">
                Edu Square is an educational initiative under Pentomino Solutions, dedicated to empowering individuals through skill-based learning and practical experience. As a key sub-service of our organization, Edu Square offers a holistic approach to training and development, fostering both technical acumen and soft skills for future-ready professionals.
            </p>

            <h2 className="text-xl font-semibold text-white mt-6 mb-6">Our Offerings</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {offerings.map((item, index) => (
                    <div
                        key={index}
                        className="bg-gray-900 p-4 rounded-lg shadow-lg flex items-center space-x-4 w-full h-40 transition-all duration-300 transform hover:-translate-y-2 hover:bg-white hover:shadow-2xl hover:shadow-green-400 hover:text-black"
                    >
                        <div className="text-green-500 text-4xl">{item.icon}</div>
                        <p className="text-sm font-medium">{item.title}</p>
                    </div>
                ))}
            </div>

            <h2 className="text-xl font-semibold text-white mt-12 mb-2">Recent Engagement</h2>
            <p className="mb-4">
                We successfully conducted two days hands-on seminar on Flutter at <span className="text-green-400">Vidya Sanskaar Institute of Science</span> (Machohalli Main Rd, Bengaluru, Karnataka 560091), where students received exposure to real-world development practices.
            </p>
            <p className="mt-8 text-sm text-gray-400">Last updated: June 16, 2025</p>
        </div>
    </div>
);

export default EduSquarePage;